
import {defineComponent} from "vue";
import {getToken, query} from "@/utils";
import config from "@/config";

export default defineComponent({
  data() {
    return {
      links: [],

      load_promise: null as Promise<unknown>|null
    }
  },
  async mounted() {
    (this.$root as any).setShowLogout(true);


  },
  async created() {
    try {
      if (!getToken()) {
        this.$router.push('/entry');
      }
      let res = await query(config.api_url + "link_lists?cookie=" + getToken(), "GET", null, {}, false) as any;
      if (res.error)
        this.toast("danger", res.error_msg);
      else {
        if (res.links.length == 1) {
          window.location = res.links[0].link_url;
        } else if (res.links.length > 0) {
          this.links = res.links;
        } else {
          this.toast('primary', 'You have been logged out.');
          this.$router.push('/entry');
        }
      }
    } catch (e) {
      this.toast("danger", "Could not connect to server");
    }
  },
  methods: {
    toast(color: string, text:string) {
      return (this.$root as any).toast(color, text);
    },
    open() {
      let v: string = (this.$refs.sel as HTMLSelectElement).value as string;
      window.location.assign(v);
    }
  }
});
